import { Checkbox } from 'antd';
import { useState } from 'react';
import { useForm } from '../../context';
import Address from '../Address';
import BasicInfo from '../BasicInfo';

export const FinancialResponsible = () => {
  const { checkout, form, isFinancialResponsibleForeigner, setFinancialResponsibleForeignerMode } = useForm();
  const [isFinancialResponsible, setIsFinancialResponsible] = useState(true);
  const [isFinancialResponsibleAddressSame, setIsFinancialResponsibleAddressSame] = useState(true);

  if (!checkout?.askFinancialResponsible) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="font-medium">Você é o responsável financeiro?</div>
      <div className="flex items-center gap-4 mt-2">
        <Checkbox
          checked={isFinancialResponsible}
          onChange={() => {
            setIsFinancialResponsible(true);
            form.setFieldsValue({ financialResponsible: undefined });
          }}
        >
          Sim
        </Checkbox>

        <Checkbox
          checked={!isFinancialResponsible}
          onChange={() => {
            setIsFinancialResponsible(false);
          }}
        >
          Não
        </Checkbox>
      </div>

      {!isFinancialResponsible && (
        <div className="mt-4">
          <BasicInfo name={['financialResponsible']} onChangeForeigner={setFinancialResponsibleForeignerMode} isForeigner={isFinancialResponsibleForeigner} />

          {checkout.askAddress && (
            <div className="mt-4">
              <div className="font-medium">Endereço do responsável financeiro é o mesmo?</div>
              <div className="flex items-center gap-4 mt-2">
                <Checkbox
                  checked={isFinancialResponsibleAddressSame}
                  onChange={() => {
                    setIsFinancialResponsibleAddressSame(true);
                    form.setFieldsValue({ financialResponsible: { address: undefined } });
                  }}
                >
                  Sim
                </Checkbox>

                <Checkbox
                  checked={!isFinancialResponsibleAddressSame}
                  onChange={() => {
                    setIsFinancialResponsibleAddressSame(false);
                  }}
                >
                  Não
                </Checkbox>
              </div>

              {!isFinancialResponsibleAddressSame && (
                <div className="mt-4">
                  <Address name={['financialResponsible', 'address']} isForeigner={isFinancialResponsibleForeigner} />
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
